import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Tooltip } from '@mui/material';
import { type FC } from 'react';

import { type ActivityReviewPriority } from '@okvc/schema';

const HIGH_PRIORITY_TITLE = 'High review priority — the AI was unsure, or the rules overrode the code it named';

interface Props {
  priority: ActivityReviewPriority | undefined;
}

/** Renders nothing for normal priority, so it can sit unconditionally beside any code chip. */
const ActivityReviewPriorityMarker: FC<Props> = ({ priority }) => {
  if (priority !== 'high') {
    return null;
  }
  return (
    <Tooltip arrow title={HIGH_PRIORITY_TITLE}>
      <PriorityHighIcon
        aria-label={'High review priority'}
        sx={{
          fontSize: 16,
          color: 'warning.contrastText',
          bgcolor: 'warning.main',
          borderRadius: '50%',
          p: '1px',
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
};

export default ActivityReviewPriorityMarker;
